import React, { useCallback } from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import Slider from 'components/uiKit/Slider'
import type { ISliderProps } from 'components/uiKit/Slider/Slider'

const FieldSelect = ({ name, onChange, ...rest }: AdapterKitControlProps<ISliderProps, number>) => {
  const handleChange = useCallback((value: number) => onChange({ name, value }), [name, onChange])

  return <Slider {...rest} name={name} onChange={handleChange} />
}

export default React.memo(FieldSelect) as typeof FieldSelect
